import { render, staticRenderFns } from "./PaHealthDeclaration.vue?vue&type=template&id=7e285644&scoped=true"
import script from "./PaHealthDeclaration.vue?vue&type=script&lang=js"
export * from "./PaHealthDeclaration.vue?vue&type=script&lang=js"
import style0 from "./PaHealthDeclaration.vue?vue&type=style&index=0&id=7e285644&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e285644",
  null
  
)

export default component.exports